import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getCountOfType as m } from "../../counting/index.js";
import { getLevelArrayMetric as p } from "../index4.js";
const l = (r) => p(r, (e, o) => m(e, t.Module, o));
export {
  l as getLevelArrayModuleCount
};
//# sourceMappingURL=index10.js.map
